import { BASE_DATETIME } from '@/utvStore/components/recommend/lp/commons'

import moment from 'moment'
const now = new moment()
const diffFromBase = now.diff(BASE_DATETIME, 'years')

const baseInfo = {
  id: 2,
  name: '叶ここ',
  kana: 'かのうここ',
  roman: 'Kanoucoco',
  mainMethod: '天宝占術',
  mainMethodKana: 'てんぽうせんじゅつ',
}

const additionalInfo = {
  description: `スペイン人魔術師の祖父、フィリピン人祈祷師の祖母を持つ、魔女占い師。自然の力を生かすナチュラルマジックを得意とし、人生を豊かに生きるための方法の１つとして魔法の世界を伝えている。そのリーディングは、相談者が語る現実のさらに奥にある因縁を的確につかみ、言葉でほぐしていく。`,
  methods: '天宝占術、マルセイユ・タロット、手相',
  yearsOfAppraisal: `${diffFromBase + 9}年(無料で鑑定していた時代を合わせると${diffFromBase + 16}年)`,
  appraisalNum: '約３万人以上',
  managementOffice: {
    name: 'Luck Out',
    url: '',
  },
}

const forProfilePage = {
  realNameBornPlaceAge: '非公表',
  basicFortune: `/recommend/${baseInfo.id}/basic/input`,
  profileImage: '/static/img/recommend/lp/kanoucoco/profileImage1.png',
  directAppraisal: {
    message: '占い師本人による直接鑑定は、現在WEBサービスでの特典（抽選制）でのみの受付となっています。詳細は各サービスの情報をご覧ください'
  },
  digitalFortune: {
    name: '占いTV',
    url: '',
  },
  salonTypeCommunity: {
    name: 'BaseCamp（月額制／毎月抽選での有料鑑定あり）',
    url: '',
  }
}

const tellerList = {
  description: '魔術と本格占術を巧みに操り、心深くを読み解く正統派魔女占い師',
  thumbnail: '/static/img/recommend/lp/kanoucoco/counselor_160x160.jpg',
}

export default {
  ...baseInfo,
  ...additionalInfo,
  profilePage: forProfilePage,
  tellerList,
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/recommend/lp/counselor/kanoucoco/info/profile.js